import React, { Dispatch, ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FieldData } from 'rc-field-form/lib/interface';
import { Button, Form, FormInstance, Space } from 'antd';
import { isEmpty } from 'lodash';

import { ContractFilter } from 'pricing/types';
import { ContractListingAction } from 'pricing/pages/contractList/ContractList.state';
import { ContractListRouteParams } from 'pricing/pages/contractList/ContractList';
import { testId } from 'pricing/utilities/test/dataTestId';
import FilterFieldContractTermTypes from './contractListFiltersFormFields/filterFieldContractTermTypes/FilterFieldContractTermTypes';
import FilterFieldBreeds from './contractListFiltersFormFields/filterFieldBreeds/FilterFieldBreeds';
import FilterFieldColors from './contractListFiltersFormFields/filterFieldColors/FilterFieldColors';
import FilterFieldPuppyVarieties from './contractListFiltersFormFields/filterFieldPuppyVarieties/FilterFieldPuppyVarieties';

interface Props {
  dispatch: Dispatch<ContractListingAction>;
  form: FormInstance;
}

function ContractListFiltersForm(props: Props): ReactElement {
  const { dispatch, form } = props;
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const { category, query } = useParams<ContractListRouteParams>();
  const isCategoryContract = category === 'contract_id';

  const onFinish = (values: ContractFilter) => {
    setLoading(true);

    dispatch({
      type: 'FILTER_CONTRACTS',
      payload: values,
    });
    dispatch({ type: 'LOAD_CONTRACTS' });
    setLoading(false);
  };

  const resetBtn = () => {
    form.resetFields();
    setDisabled(true);

    if (category && query) {
      dispatch({
        type: 'SEARCH_CONTRACTS',
        payload: { [category]: query },
      });
    }

    dispatch({
      type: 'FILTER_CONTRACTS',
      payload: {},
    });
    dispatch({ type: 'LOAD_CONTRACTS' });
    dispatch({ type: 'EXPAND_ALL_CONTRACTS', payload: false });
  };

  const handleOnFieldsChange = (changedFields: FieldData[]) => {
    setDisabled(!form.isFieldsTouched());

    if (isEmpty(changedFields)) return;

    const [{ name }] = changedFields;

    if (typeof name === 'object') {
      if (name[0] === 'breed_id') {
        form?.resetFields(['color_ids', 'variety_ids']);
      }
    }
  };

  return (
    <Form
      data-testid={testId.contractListFilterForm}
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onFieldsChange={handleOnFieldsChange}
    >
      <Space size={16}>
        <label>Filter by:</label>
        <FilterFieldContractTermTypes disabled={isCategoryContract} />
        <FilterFieldBreeds disabled={isCategoryContract} />
        <FilterFieldColors disabled={isCategoryContract} />
        <FilterFieldPuppyVarieties disabled={isCategoryContract} />
        <Button
          data-testid={testId.contractListFilterFormSubmit}
          type="primary"
          htmlType="submit"
          disabled={disabled || isCategoryContract}
          loading={loading}
        >
          Ok
        </Button>
        <Button
          data-testid={testId.contractListFilterFormClear}
          onClick={resetBtn}
          disabled={isCategoryContract}
        >
          Clear
        </Button>
      </Space>
    </Form>
  );
}

export default ContractListFiltersForm;
